import { useDroppable } from '@dnd-kit/core';
import type { LoteKanban } from '@/types';
import { LoteCard } from './LoteCard';
import { contrastingText } from '@/lib/utils';

interface Props {
  faseId: number;
  faseNombre: string;
  faseColor: string;
  lotes: LoteKanban[];
}

export function LotesKanbanColumn({ faseId, faseNombre, faseColor, lotes }: Props) {
  const headerText = contrastingText(faseColor);
  const { setNodeRef, isOver } = useDroppable({
    id: `fase-${faseId}`,
    data: { type: 'fase', faseId },
  });

  return (
    <div
      className={`flex flex-col bg-stone-100 rounded-md min-w-[260px] max-w-[280px] flex-shrink-0
        ${isOver ? 'ring-2 ring-brand-green-100 ring-offset-1' : ''}`}
    >
      <div
        className="flex items-center justify-between px-3 py-2.5 rounded-t-md"
        style={{ background: faseColor, color: headerText }}
      >
        <span className="font-semibold text-sm">{faseNombre}</span>
        <span
          className="text-xs px-2 py-0.5 rounded-full font-medium border"
          style={{ borderColor: headerText, color: headerText }}
        >
          {lotes.length}
        </span>
      </div>

      <div
        ref={setNodeRef}
        className="flex-1 overflow-y-auto p-2 space-y-1.5 min-h-[200px]"
      >
        {lotes.map(l => <LoteCard key={l.idLote} lote={l} />)}
        {lotes.length === 0 && (
          <div className="text-xs text-stone-400 text-center py-8 italic">
            Soltá un lote aquí
          </div>
        )}
      </div>
    </div>
  );
}
